export function renderInIframe(container, safeHTML) {
  const iframe = document.createElement('iframe');

  iframe.style.width = '100%';
  iframe.style.border = '0';
  iframe.style.display = 'block';

  iframe.addEventListener('load', () => {
    updateIframeHeight(iframe);
    observeIframeHeight(iframe);
  });

  container.appendChild(iframe);

  iframe.srcdoc = safeHTML;

  return iframe;
}

function getContentHeight(iframe) {
  const doc = iframe.contentDocument || iframe.contentWindow.document;

  return Math.max(
    doc.body?.scrollHeight || 0,
    doc.body?.offsetHeight || 0,
    doc.documentElement?.scrollHeight || 0,
    doc.documentElement?.offsetHeight || 0,
    doc.documentElement?.clientHeight || 0
  );
}

function updateIframeHeight(iframe) {
  iframe.style.height = `${getContentHeight(iframe)}px`;
}

function observeIframeHeight(iframe) {
  const doc = iframe.contentDocument || iframe.contentWindow.document;

  const observer = new ResizeObserver(() => {
    updateIframeHeight(iframe);
  });

  observer.observe(doc.documentElement);

  if (doc.body) {
    observer.observe(doc.body);
  }

  updateIframeHeight(iframe);

  return observer;
}